import React from 'react'
import TextField from '@material-ui/core/TextField'
import {onUnknownChangeHandler} from 'lib/dom'
import CloseIcon from '@material-ui/icons/Close'
import EmojiSelect from 'Event/Dashboard/components/EmojiList/EmojiSelect'
import EmojiUpload from 'Event/Dashboard/components/EmojiList/EmojiUpload'
import styled from 'styled-components'
import IconButton from 'lib/ui/IconButton'
import {
  DEFAULT_EMOJIS,
  createCustomEmoji,
  Emoji,
  isCustom,
} from 'Event/Dashboard/components/EmojiList/emoji'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'

export default function Settings(props: {
  emojiWidth?: number | null
  setEmojiWidth: (newEmojiWidth: number) => void
  emojis: string[]
  setEmojis: (newEmojis: string[]) => void
}) {
  const {emojiWidth, setEmojiWidth, emojis, setEmojis} = props
  const deleteFile = useDeleteFile()

  const customEmojis = emojis.filter(isCustom).map(createCustomEmoji)
  const availableEmojis = [...DEFAULT_EMOJIS, ...customEmojis]

  const updateEmoji = (index: number) => (target: Emoji['name']) => {
    const updated = emojis.map((e, i) => {
      const isTarget = i === index
      if (isTarget) {
        return target
      }

      return e
    })

    setEmojis(updated)
  }

  const addNewEmoji = (emoji: Emoji['name']) => {
    const added = [...emojis, emoji]
    setEmojis(added)
  }

  const remove = (index: number) => () => {
    const emoji = emojis[index]
    const isLast = emojis.filter((e) => e === emoji).length === 1
    if (isCustom(emoji) && isLast) {
      deleteFile(emoji)
    }

    const removed = emojis.filter((e, i) => i !== index)
    setEmojis(removed)
  }

  return (
    <>
      <TextField
        type="number"
        value={emojiWidth || ''}
        label="Emoji Size"
        onChange={onUnknownChangeHandler(setEmojiWidth)}
        fullWidth
        inputProps={{
          step: 5,
          min: 20,
        }}
      />
      {emojis.map((emoji, index) => (
        <ExistingEmoji key={index}>
          <EmojiSelect
            emojis={availableEmojis}
            value={emoji}
            onPick={updateEmoji(index)}
          />
          <RemoveButton aria-label="remove emoji" onClick={remove(index)}>
            <CloseIcon color="error" />
          </RemoveButton>
        </ExistingEmoji>
      ))}
      <EmojiSelect value="" emojis={availableEmojis} onPick={addNewEmoji} />
      <EmojiUpload onSuccess={addNewEmoji} />
    </>
  )
}

const ExistingEmoji = styled.div`
  display: flex;
  align-items: center;
`

const RemoveButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
`

function useDeleteFile() {
  const {event} = useEvent()
  const {client} = useOrganization()

  return (emoji: string) => {
    const url = api(`/events/${event.id}/emojis/${emoji}`)
    return client.delete(url)
  }
}
